import axios, { AxiosRequestConfig, AxiosError } from 'axios'
import store from 'redux/store/index'
import { setLoadingCounter } from 'redux/store/actions'
import { createStandaloneToast } from '@chakra-ui/react'

const { toast } = createStandaloneToast()
const handleError = (error: any) => {
  let description
  if (!error.response) {
    // in case internal server error 500
    if (navigator.onLine) {
      description = 'something went wrong with your request.please try again later'
    } else {
      description = 'please check your connection'
    }
  } else if (error.response.status === 401) {
    // in case unauthorized  401
    localStorage.removeItem('user')
    // dispatch({ type: IS_LOGIN, payload: false })
    // dispatch({ type: RESET_USER_DATA })
    // history.push('/login')
  } else if (error.response.status === 404) {
    // description = 'Item not found'
  } else if (error.response.data && error.response.data.errors?.length) {
    // error.response.data.errors?.map((x: any) => {
    //   return toast({
    //     description: x.errorMessage,
    //     title: 'An error occurred',
    //     status: 'error',
    //     duration: 5000,
    //     isClosable: true,
    //   })
    // })
  } else {
    description = 'something went wrong with your request.please try again later'
  }
  if (description) {
    toast({
      description,
      title: 'An error occurred',
      status: 'error',
      duration: 5000,
      isClosable: true,
    })
  }
}
export const axiosBaseQuery = ({
  baseUrl = 'http://gammats.com:7001/be',
}: {
  baseUrl: string | undefined
}) => {
  return async ({
    url,
    params,
    method,
    body,
    headers,
  }: {
    url: string
    method: AxiosRequestConfig['method']
    body?: AxiosRequestConfig['data']
    params?: AxiosRequestConfig['params']
    headers?: AxiosRequestConfig['headers']
  }) => {
    try {
      // Add a request interceptor
      axios.interceptors.request.use(
        config => {
          // Do something before request is sent
          // store.dispatch(setLoadingCounter(1))
          return config
        },
        error => {
          // Do something with request error
          // store.dispatch(setLoadingCounter(1))
          return Promise.reject(error)
        }
      )
      // Add a response interceptor
      axios.interceptors.response.use(
        response => {
          // Any status code that lie within the range of 2xx cause this function to trigger
          // Do something with response data
          // store.dispatch(setLoadingCounter(-1))
          return response
        },
        error => {
          // Any status codes that falls outside the range of 2xx cause this function to trigger
          // Do something with response error
          // store.dispatch(setLoadingCounter(-1))

          return Promise.reject(error)
        }
      )
      const result = await axios({
        url: baseUrl + url,
        method,
        ...(params && { params }),
        ...(headers && { headers }),
        ...(body && { data: body }),
      })
      return {
        data: result.data,
      }
    } catch (axiosError) {
      const err = axiosError as AxiosError
      handleError(axiosError)
      return {
        error: { status: err.response?.status, data: err.response?.data },
      }
    }
  }
}
const baseQuery = axiosBaseQuery({ baseUrl: process.env.REACT_APP_API_KEY })

export const baseQueryWithErrorHandler = async (args: any): Promise<any> => {
  const result = await baseQuery(args)
  // if (result?.data?.errors) {
  //   const error = result?.data?.errors
  // }
  return result
}
